"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ImageResizer = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageResizer, _React$Component);

  function ImageResizer(props) {
    var _this;

    _classCallCheck(this, ImageResizer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImageResizer).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "drawImage", function () {
      var src = _this.props.src;
      if (!src) return;
      var image = new Image();

      image.onload = function () {
        var minRatio = _this.props.minRatio;

        if (!_this.canvas || !_this.canvas.current) {
          return;
        }

        var canvas = _this.canvas.current;
        var width = image.width >= image.height * minRatio ? image.width : image.height * minRatio;
        var height = image.height;
        var canvasContext = canvas.getContext('2d');
        canvas.width = width;
        canvas.height = height;
        canvasContext.drawImage(image, (width - image.width) / 2, 0);
      };

      image.src = src;
    });

    _this.canvas = _react2["default"].createRef();
    return _this;
  }

  _createClass(ImageResizer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.drawImage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.src !== this.props.src) {
        this.drawImage();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alt = _this$props.alt,
          className = _this$props.className;
      return _react2["default"].createElement("canvas", {
        ref: this.canvas,
        alt: alt,
        className: className
      });
    }
  }]);

  return ImageResizer;
}(_react2["default"].Component);

ImageResizer.propTypes = {
  src: _propTypes2["default"].string,
  alt: _propTypes2["default"].string,
  minRatio: _propTypes2["default"].number,
  className: _propTypes2["default"].string
};
exports["default"] = ImageResizer;